// @flow
import * as React from 'react';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import classNames from 'classnames';
import { faHeart as farHeart } from '@fortawesome/pro-regular-svg-icons/faHeart';
import { faHeart as fasHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import styles from './ItemSaveButton.module.scss';

type Props = {
    className: string,
    save: Function,
    saved: boolean,
    savedCount: number,
    showSavedCount: boolean,
};

const ItemSaveButton = ({ className, save, saved = false, savedCount = 0, showSavedCount = false }: Props) => {
    const icon = saved ? fasHeart : farHeart;

    const wrapperClasses = classNames(styles['live-item-save'], className);
    const buttonClasses = classNames(styles.button, { [styles.saved]: saved });

    const showCount = showSavedCount && savedCount > 0;
    const countMessageId = showCount && savedCount > 1 ? 'bidders_saved_item' : 'bidder_saved_item';

    return (
        <div className={wrapperClasses}>
            <Button className={buttonClasses} onClick={save} secondary e2e="itemPageSaveItemButton">
                <FontAwesomeIcon className={styles.icon} icon={icon} />
                {!saved ? <FormattedMessage id="save_item" /> : <FormattedMessage id="item_saved" />}
            </Button>
            {showCount && (
                <div className={styles['message-wrapper']}>
                    <FormattedMessage id={countMessageId} values={{ savedCount }} />
                </div>
            )}
        </div>
    );
};

export default React.memo<Props>(ItemSaveButton, isEqual);
